<template>
  <div>
    <v-data-table
      :page="table.page"
      :headers="headers"
      :items="table.items"
      :items-per-page="-1"
      :loading="loading.table"
      :server-items-length="table.totalCount"
      hide-default-footer
      :no-data-text="$t('defaults.table.no-data-text')"
      :loading-text="$t('defaults.table.loading-text')"
      :options.sync="table.options"
      class="d-table"
      @update:options="optionsUpdated"
    >
      <template v-slot:[`item.isActive`]="{ item }">
        <v-chip outlined :color="item.isActive ? 'success' : 'error'">{{
          item.isActive
            ? $t("defaults.text.active")
            : $t("defaults.text.inactive")
        }}</v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-end">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="gray darken-2"
                icon
                @click="$emit('edit', item)"
              >
                <v-icon size="24"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("defaults.button.edit") }}</span>
          </v-tooltip>

          <v-menu bottom offset-y content-class="elevation-0 mt-1 rounded">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="gray darken-2" icon>
                      <v-icon> mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("defaults.text.other-actions") }}</span>
                </v-tooltip>
              </div>
            </template>

            <v-list outlined class="rounded" dense>
              <v-list-item @click="$emit('changeStatus', item)">
                <v-list-item-title>
                  <span class="body-2">{{
                    item.isActive
                      ? $t("defaults.button.deactivate")
                      : $t("defaults.button.activate")
                  }}</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item
                :to="{
                  name: 'ProjectApisLogs',
                  params: { projectId, apiId: item.id },
                }"
              >
                <v-list-item-title>
                  <span class="body-2">{{
                    $t("defaults.button.view-log")
                  }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import tableMixins from "@/mixins/tableMixins";
import { getProjectApis } from "@/services/project";

export default {
  mixins: [tableMixins],
  props: {
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("project-apis.list.table.headers.status"),
          value: "isActive",
          sortable: false,
          width: "100px",
        },
        {
          text: this.$t("project-apis.list.table.headers.name"),
          value: "name",
          sortable: false,
        },
        {
          text: this.$t("project-apis.list.table.headers.slug"),
          value: "slug",
          sortable: false,
        },
        {
          text: this.$t("project-apis.list.table.headers.method"),
          value: "httpMethodName",
          sortable: false,
        },

        {
          text: this.$t("project-apis.list.table.headers.api-url"),
          value: "apiUrl",
          sortable: false,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  methods: {
    handleFetchItems() {
      this.fetchItems();
    },
    fetchItems() {
      this.loading.table = true;
      getProjectApis(this.$route.params.id)
        .then((response) => {
          this.table.items = response;
          this.table.totalCount = response.length;
        })
        .catch(() => {
          this.table.items = [];
          this.table.totalCount = 0;
        })
        .finally(() => {
          this.loading.table = false;
        });
    },
  },
  mounted() {
    this.$eventBus.$on("fetchProjectApis", this.handleFetchItems);
  },
  beforeDestroy() {
    this.$eventBus.$off("fetchProjectApis", this.handleFetchItem);
  },
};
</script>
